import { AsyncPipe, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContractRoutingModule } from './contract-routing/contract-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ContractTypeFormComponent } from './contract-master/contract-type/contract-type-form/contract-type-form.component';
import { ContractTypeListComponent } from './contract-master/contract-type/contract-type-list/contract-type-list.component';
import { ContractTypeComponent } from './contract-master/contract-type/contract-type.component';
import { ContractTypeService } from './shared/contract-type.service';
import { ContractService } from './shared/contract.service';

import { ContractMasterComponent } from './contract-master/contract-master.component';
import { ContractFormComponent } from './contract-master/contract/contract-form/contract-form.component';
import { ContractApprovalsComponent } from './contract-master/contract/contract-form/enter-validation/contract-approvals/contract-approvals.component';
import { ContractSupportingDocumentsComponent } from './contract-master/contract/contract-form/enter-validation/contract-supporting-documents/contract-supporting-documents.component';
import { EnterValidationComponent } from './contract-master/contract/contract-form/enter-validation/enter-validation.component';
import { ContractListComponent } from './contract-master/contract/contract-list/contract-list.component';
import { ContractComponent } from './contract-master/contract/contract.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxFileDropModule } from 'ngx-file-drop';

import { MaterialModule } from '../app-material/material/material.module';
import { DashboardComponent } from './contract-master/dashboard/dashboard.component';

import { ToastrModule } from 'ngx-toastr';
import { AddClauseComponent } from './contract-master/clause/add-clause/add-clause.component';
import { ClauseListComponent } from './contract-master/clause/clause-list/clause-list.component';
import { ClauseComponent } from './contract-master/clause/clause.component';
import { ContractClauseComponent } from './contract-master/contract/contract-form/enter-validation/contract-clause/contract-clause.component';
import { ContractReviewerComponent } from './contract-master/contract/contract-form/enter-validation/contract-reviewer/contract-reviewer.component';
import { TemplateComponent } from './contract-master/template/template.component';
import { UserListComponent } from './contract-master/user-management/user-list/user-list.component';


import { RoleFormComponent } from './contract-master/user-management/role-form/role-form.component';
import { RoleListComponent } from './contract-master/user-management/role-list/role-list.component';
import { UserFormComponent } from './contract-master/user-management/user-form/user-form.component';
import { UserManagementComponent } from './contract-master/user-management/user-management.component';
import { UserManagementService } from './shared/user-management.service';

import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgIconsModule, provideNgIconsConfig } from '@ng-icons/core';
import { faFileWord, faFilePdf } from '@ng-icons/font-awesome/regular';
import { heroArrowDownTray, heroArrowTopRightOnSquare, heroArrowUpTray, heroBars3BottomLeft, heroBellAlert, heroChatBubbleBottomCenterText, heroChatBubbleLeftRight, heroChevronDoubleLeft, heroChevronDown, heroCircleStack, heroClipboardDocument, heroClipboardDocumentCheck, heroCog8Tooth, heroDocument, heroDocumentMagnifyingGlass, heroEye, heroEyeSlash, heroMagnifyingGlass, heroPencil, heroPower, heroQuestionMarkCircle, heroSquares2x2, heroTrash, heroUser, heroUserCircle, heroUserGroup, heroXMark, heroUserPlus, heroEllipsisVertical, heroClipboardDocumentList, heroGlobeAlt, heroDocumentText, heroPencilSquare, heroDocumentPlus, heroUsers, heroGlobeAsiaAustralia, heroNewspaper, heroPlusCircle, heroChatBubbleLeftEllipsis, heroGlobeEuropeAfrica, heroCubeTransparent, heroInformationCircle, heroCamera, heroMagnifyingGlassCircle, heroFolderPlus, heroPrinter , heroCheck, heroDocumentArrowUp, heroCheckBadge } from '@ng-icons/heroicons/outline';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { GroupByPipe } from '../shared/group-by.pipe';
import { PartialsComponent } from '../shared/partials/partials.component';
import { AttributeFormComponent } from './contract-master/attributes/attribute-form/attribute-form.component';
import { AttributeTypeListComponent } from './contract-master/attributes/attribute-type-list/attribute-type-list.component';
import { AttributesComponent } from './contract-master/attributes/attributes.component';
import { ClauseComparisionDialogComponent } from './contract-master/contract/contract-form/clause-comparision-dialog/clause-comparision-dialog.component';
import { ClauseLogDialogComponent } from './contract-master/contract/contract-form/clause-log-dialog/clause-log-dialog.component';
import { ContractHistoryComponent } from './contract-master/contract/contract-form/enter-validation/contract-history/contract-history.component';
import { ContractNotesComponent } from './contract-master/contract/contract-form/enter-validation/contract-notes/contract-notes.component';
import { AddNoteDialogComponent } from './contract-master/contract/contract-form/enter-validation/contract-notes/add-note-dialog/add-note-dialog.component';
import { ViewNotesDialogComponent } from './contract-master/contract/contract-form/enter-validation/contract-notes/view-notes-dialog/view-notes-dialog.component';
import { DeleteDialogComponent } from './contract-master/delete-dialog/delete-dialog.component';
import { GraphChartComponent } from './contract-master/graph-chart/graph-chart.component';
import { RejectDialogComponent } from './contract-master/reject-dialog/reject-dialog.component';
import { RecallDialogComponent } from './contract-master/recall-dialog/recall-dialog.component';
import { TaskDialogComponent } from './contract-master/task-dialog/task-dialog.component';
import { NotificationFormComponent } from './notifications/notification-form/notification-form.component';
import { NotificationListComponent } from './notifications/notification-list/notification-list.component';
import { NotificationMasterComponent } from './notifications/notification-master/notification-master.component';
import { NotificationService } from './notifications/shared/notification.service';
import { ContractSignatureComponent } from './contract-master/contract/contract-form/contract-signature/contract-signature.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DndModule } from 'ngx-drag-drop';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AddSignatoryComponent } from './contract-master/contract/contract-form/contract-signature/add-signatory/add-signatory.component';
import { AddTeamDialogComponent } from './contract-master/contract/contract-form/add-team-dialog/add-team-dialog.component';

import { ReportsComponent } from './contract-master/reports/reports.component';

import { OrganisationFormComponent } from './contract-master/user-management/organisation-form/organisation-form.component';
import { OrganisationListComponent } from './contract-master/user-management/organisation-list/organisation-list.component';
import { RejectReasonDialogComponent } from './contract-master/contract/contract-form/enter-validation/reject-reason-dialog/reject-reason-dialog.component';
import { AboutComponent } from './contract-master/about/about.component';
import { SearchResultComponent } from './contract-master/search-result/search-result.component';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { ToolbarModule } from 'primeng/toolbar';
import { TagModule } from 'primeng/tag';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ChipsModule } from 'primeng/chips';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { SliderModule } from 'primeng/slider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ReportChartComponent } from './contract-master/report-chart/report-chart.component';
import { ResultSearchComponent } from './contract-master/result-search/result-search.component';
import { ConfirmDialogComponent } from './contract-master/confirm-dialog/confirm-dialog.component';
import { CustomComponent } from './contract-master/contract/contract-form/contract-signature/custom/custom.component';
import { TerminateDialogComponent } from './contract-master/contract/contract-form/terminate-dialog/terminate-dialog.component';
import { KpiDialogComponent } from './contract-master/kpi-dialog/kpi-dialog.component';
import { EmSignerComponent } from './contract-master/em-signer/em-signer.component';
import { HelloSignComponent } from './contract-master/hello-sign/hello-sign.component';
import { EmSignerService } from './shared/em-signer.service';
import { HelloSignService } from './shared/hello-sign.service';
import { DocuSignService } from './shared/docusign.service';

@NgModule({
  declarations: [CustomComponent,
    ContractTypeComponent, ContractTypeListComponent, ContractTypeFormComponent, ContractMasterComponent, ContractComponent, ContractListComponent, ContractFormComponent, EnterValidationComponent, ContractApprovalsComponent, ContractSupportingDocumentsComponent, DashboardComponent, ContractReviewerComponent, ClauseComponent, ClauseListComponent, AddClauseComponent, ContractClauseComponent, UserListComponent, TemplateComponent, UserManagementComponent, UserFormComponent, RoleFormComponent, RoleListComponent, NotificationFormComponent, NotificationListComponent, NotificationMasterComponent, PartialsComponent, GraphChartComponent, DeleteDialogComponent, TaskDialogComponent, AttributeTypeListComponent, AttributeFormComponent, RejectDialogComponent, RecallDialogComponent, AttributesComponent, GroupByPipe, ClauseComparisionDialogComponent, ClauseLogDialogComponent, ContractHistoryComponent, ContractNotesComponent, AddNoteDialogComponent, ViewNotesDialogComponent, ContractSignatureComponent, AddSignatoryComponent, AddTeamDialogComponent, ReportsComponent, OrganisationListComponent, OrganisationFormComponent, RejectReasonDialogComponent,AboutComponent,SearchResultComponent,ReportChartComponent,ResultSearchComponent, ConfirmDialogComponent,TerminateDialogComponent,KpiDialogComponent, EmSignerComponent, HelloSignComponent

  ],
  imports: [
    AngularEditorModule,
    CommonModule,
    ContractRoutingModule,
    PdfViewerModule,
    HttpClientModule,
    DndModule,
    NgxExtendedPdfViewerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDocViewerModule,
    AsyncPipe,
    TableModule,  
    ButtonModule,
    ToolbarModule,
    InputTextModule,
    TagModule,
    ProgressBarModule,
    ToastModule,
    IconFieldModule,
    InputIconModule,
    ChipsModule,
    InputMaskModule,
    InputNumberModule,
    InputSwitchModule,
    InputTextareaModule,
    InputGroupAddonModule,
    InputGroupModule,
    MultiSelectModule,
    DropdownModule,
    SliderModule,
    ProgressSpinnerModule,
    TooltipModule,
    CalendarModule,
    CheckboxModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgIconsModule.withIcons({ heroChevronDown, heroEye, heroBars3BottomLeft, heroSquares2x2, heroChevronDoubleLeft, heroUserCircle, heroUserGroup, heroPencil, heroClipboardDocumentCheck, heroClipboardDocument, heroDocument, heroChatBubbleBottomCenterText, heroTrash, heroPower, faFileWord, faFilePdf, heroMagnifyingGlass, heroXMark, heroEyeSlash, heroArrowDownTray, heroCircleStack, heroArrowTopRightOnSquare, heroCog8Tooth, heroBellAlert, heroUser, heroQuestionMarkCircle, heroChatBubbleLeftRight, heroDocumentMagnifyingGlass, heroArrowUpTray, heroUserPlus, heroEllipsisVertical, heroClipboardDocumentList, heroGlobeAlt, heroDocumentText, heroPencilSquare, heroDocumentPlus, heroUsers,heroGlobeAsiaAustralia,heroNewspaper,heroPlusCircle,heroChatBubbleLeftEllipsis,heroGlobeEuropeAfrica,heroCubeTransparent, heroInformationCircle, heroCamera,heroMagnifyingGlassCircle,heroFolderPlus,heroPrinter,heroDocumentArrowUp,heroCheckBadge}),
    ToastrModule.forRoot({
      closeButton: true,
      positionClass: 'toast-top-right',
      progressBar: true
    }),
    NgxFileDropModule,
    MaterialModule,
    NgxSkeletonLoaderModule.forRoot({
      animation: 'pulse',
      theme: {
        extendsFromRoot: true,
        background: 'rgba(0, 0, 0, 0.05)'
      },
    })
  ],
  providers: [
    ContractTypeService,
    ContractService,
    UserManagementService,
    NotificationService,
    EmSignerService,
    HelloSignService,
    DocuSignService,
    provideNgIconsConfig({
      size: '1.5rem',
    }),
  ],
  exports: [
    CustomComponent,
    ContractTypeComponent, ContractTypeListComponent, ContractTypeFormComponent, ContractMasterComponent, ContractComponent, ContractListComponent, ContractFormComponent
    , ClauseComponent, ClauseListComponent, NotificationFormComponent, NotificationListComponent, NotificationMasterComponent, PartialsComponent]
})
export class ContractModule { }
